import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CargoHostDialogComponent } from '@cargo/components/cargo-host-dialog/cargo-host-dialog.component';
import { CargoDialogResult } from '@cargo/models/cargo-dialog-result';
import { CargoHostDialogParams } from '@cargo/models/cargo-host-dialog-params';
import { AppConfig } from '@core/models/app-config';
import { AppConfigService } from '@core/services/app-config.service';
import { Logger } from '@core/services/logger.service';
import { Observable, of } from 'rxjs';
import { SubSink } from 'subsink';

// When the service composes the Cargo URLs and provides them to a dialog, we can have only one dialog compoennt to host different Cargo forms

@Injectable({
	providedIn: 'any'
})
export class CargoDialogService {

	private readonly COMPONENT_NAME = "CargoDialogService";

	private _cargoUploadReadyMaterialUrl: string | undefined;
	private _cargoProductionRequestUrl: string | undefined;

	private _subs = new SubSink();

	constructor (
		private _appConfigService: AppConfigService,
		private _logger: Logger,
		private _matDialog: MatDialog
	) {
		this._subs.add(
			this._appConfigService.config$.subscribe((appConfig: AppConfig | undefined) => {
				if (appConfig) {
					if (appConfig.cargoUploadReadyMaterialUrl) {
						this._cargoUploadReadyMaterialUrl = appConfig.cargoUploadReadyMaterialUrl;
					}

					if (appConfig.cargoProductionRequestUrl) {
						this._cargoProductionRequestUrl = appConfig.cargoProductionRequestUrl;
					}
				}
			}));
	}

	displayUploadReadyMaterialDialog(titleKey: string, orderId: string, materialId: string, widthMM: number, heightMM: number): Observable<CargoDialogResult> {
		if (!this._cargoUploadReadyMaterialUrl) {
			this._logger.error(this.COMPONENT_NAME, "displayUploadReadyMaterialDialog() is called but the cargoUploadReadyMaterialUrl is not configured in the app-config.json file");
			const errorDialogResult = new CargoDialogResult();
			return of(errorDialogResult);
		}

		const cargoUploadReadyMaterialUrl = `${this._cargoUploadReadyMaterialUrl}&RialtoID=${orderId}_${materialId}&Width=${widthMM}&Height=${heightMM}`;

		const cargoDialogRef = this._matDialog.open(CargoHostDialogComponent, {
			data: new CargoHostDialogParams(titleKey, cargoUploadReadyMaterialUrl, true),
			width: "540px",
			height: "640px"
		});

		return cargoDialogRef.afterClosed();
	}

	// "We'll Create It"
	displayProductionRequestDialog(titleKey: string, orderId: string, materialId: string, widthMM: number, heightMM: number): Observable<CargoDialogResult> {
		if (!this._cargoProductionRequestUrl) {
			this._logger.error(this.COMPONENT_NAME, "displayProductionRequestDialog() is called but the cargoProductionRequestUrl is not configured in the app-config.json file");
			const errorDialogResult = new CargoDialogResult();
			return of(errorDialogResult);
		}

		const cargoProductionRequestUrl = `${this._cargoProductionRequestUrl}&RialtoID=${orderId}_${materialId}&Width=${widthMM}&Height=${heightMM}`;

		const cargoDialogRef = this._matDialog.open(CargoHostDialogComponent, {
			data: new CargoHostDialogParams(titleKey, cargoProductionRequestUrl, false),
			width: "540px",
			height: "640px"
		});

		return cargoDialogRef.afterClosed();
	}

	cleanup(): void {
		this._subs.unsubscribe();
	}
}
